import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconMicrophone = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M9.0286 8.10713C9.0286 8.71958 8.53155 9.21607 7.91842 9.21607C7.30529 9.21607 6.80825 8.71958 6.80825 8.10713V3.10782C6.80825 2.49537 7.30529 1.99889 7.91842 1.99889C8.53155 1.99889 9.0286 2.49537 9.0286 3.10782V8.10713ZM7.91842 1C6.75301 1 5.80825 1.94371 5.80825 3.10782V8.10713C5.80825 9.27125 6.75301 10.215 7.91842 10.215C9.08384 10.215 10.0286 9.27125 10.0286 8.10713V3.10782C10.0286 1.9437 9.08384 1 7.91842 1Z"
        fill="currentColor"
      />
      <path
        d="M4.39729 6.39574C4.66174 6.39574 4.87612 6.61935 4.87612 6.89518V8.04342C4.87612 9.79597 6.23822 11.2167 7.91846 11.2167C9.5987 11.2167 10.9608 9.79597 10.9608 8.04342V6.89518C10.9608 6.61935 11.1752 6.39574 11.4396 6.39574C11.7041 6.39574 11.9185 6.61935 11.9185 6.89518V8.04342C11.9185 10.1792 10.3799 11.9401 8.39583 12.1862V14.0011H9.5108C9.7753 14.0011 9.9897 14.2247 9.9897 14.5006C9.9897 14.7764 9.7753 15 9.5108 15H6.32665C6.0622 15 5.84782 14.7764 5.84782 14.5006C5.84782 14.2247 6.0622 14.0011 6.32665 14.0011H7.43816V12.1858C5.45548 11.9383 3.91846 10.1781 3.91846 8.04342V6.89518C3.91846 6.61935 4.13284 6.39574 4.39729 6.39574Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
